import { AdjustmentType } from 'enums';
import { InvoiceDetail, PaymentDetail } from 'types';
import { getAdjustmentCategoryTitle } from 'functions';
import { AdjustmentCategory, AdjustmentCategoryProps } from '../AdjustmentCategory/AdjustmentCategory';
import styles from './AdjustmentSummary.module.scss';
import { useAdjustmentTotal } from 'hooks';

type Props = {
    adjustments: (PaymentDetail | InvoiceDetail)[],
    categories: AdjustmentType[],
    selectedCategory: AdjustmentType,
    selectCategory: (category?: AdjustmentType) => void,
}

export default function AdjustmentSummary({ adjustments, categories, selectedCategory, selectCategory }: Props) {
    const getCategoryAmount = useAdjustmentTotal(adjustments);

    const categoryProps: AdjustmentCategoryProps[] = categories.map((type) => ({
        type,
        title: getAdjustmentCategoryTitle(type),
        amount: getCategoryAmount(type),
        isSelected: selectedCategory === type,
        selectCategory,
        className: styles.item
    }));

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <span>Adjustments Categories</span>
                <span className={styles.heeaderDescription}>Select a category to view lines</span>
            </div>
            <div className={styles.columnName}>
                <span>Categories</span>
                <span>Totals</span>
            </div>
            {categoryProps.map((props) => <AdjustmentCategory key={props.type} {...props} />)}
        </div>
    )
}